(function() { window.GUID_779bf9a3_1552_43e4_8287_04a1a5e3f9d5 = { getGuid: function() { return "779bf9a3-1552-43e4-8287-04a1a5e3f9d5"; } }; })();
var CS;
(function (CS) {
    var Cookie;
    (function (Cookie) {
        function GetCookie(cookieName) {
            return $.cookie("CSCookie." + cookieName);
        }
        Cookie.GetCookie = GetCookie;
        function SetCookie(cookieName, value, expires) {
            $.removeCookie("CSCookie." + cookieName);
            if (!expires)
                expires = 365;
            $.cookie("CSCookie." + cookieName, value, { expires, path: "/" });
        }
        Cookie.SetCookie = SetCookie;
        function RemoveCookie(cookieName) {
            $.removeCookie("CSCookie." + cookieName);
        }
        Cookie.RemoveCookie = RemoveCookie;
    })(Cookie = CS.Cookie || (CS.Cookie = {}));
})(CS || (CS = {}));

//# sourceMappingURL=cs-cookie.js.map
